export const CHECKOUT_PREFILL_STORAGE_KEY = 'niec_checkout_prefill';

export function writeCheckoutPrefill ( payload ) {
    try {
        sessionStorage.setItem( CHECKOUT_PREFILL_STORAGE_KEY, JSON.stringify( payload ) );
    } catch ( e ) {
        console.warn( 'Could not persist checkout prefill', e );
    }
}

export function readCheckoutPrefill () {
    try {
        const raw = sessionStorage.getItem( CHECKOUT_PREFILL_STORAGE_KEY );
        if ( !raw ) return null;
        sessionStorage.removeItem( CHECKOUT_PREFILL_STORAGE_KEY );
        return JSON.parse( raw );
    } catch {
        return null;
    }
}

/** Serialize react-hook-form schedules (Date -> ISO) for sessionStorage */
export function serializeSchedulesForPrefill ( schedules ) {
    if ( !Array.isArray( schedules ) ) return [];
    return schedules.map( ( s ) => ( {
        day: s?.day ?? null,
        time: s?.time instanceof Date ? s.time.toISOString() : ( s?.time || null ),
    } ) );
}

export function deserializeSchedulesFromPrefill ( rows ) {
    if ( !Array.isArray( rows ) ) return [ { day: null, time: null } ];
    return rows.map( ( s ) => ( {
        day: s?.day ?? null,
        time: s?.time ? new Date( s.time ) : null,
    } ) );
}
